export default __webpack_public_path__ + "static/media/female.c1a52181.svg";